import defaultImages from 'constants/images/default';
import darkThemeImages from 'constants/images/darkTheme';
import aitcOverrides from 'constants/images/aiBlurImages';

const getThemeImages = (themeKey) => {
    switch (themeKey) {
        case 'DARK_THEME':
            return darkThemeImages;
        default:
            return defaultImages;
    }
}

const getAITCImages = () => {
    return {
        ...defaultImages,
        ...aitcOverrides
    };
}

export {
    getThemeImages,
    getAITCImages
}